import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { PrepaidType } from '@shared/services/gql.service';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { MainQuery } from '@shared/store/main/main.query';

import { PrepaidTypeLabel } from '../adjustments-to-prepaid/adjustments-to-prepaid.model';

interface AgPrepaidTypeDropdownCellEditorParams extends ICellRendererParams {
  options: AgPrepaidTypeDropdownOption[];
}

type AgPrepaidTypeDropdownOption = {
  disabled: boolean;
  label: PrepaidTypeLabel;
  value: PrepaidType;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectModule, FormsModule, ReactiveFormsModule, TooltipDirective],
  styleUrl: 'ag-prepaid-type-dropdown.component.scss',
  templateUrl: 'ag-prepaid-type-dropdown.component.html',
})
export class AgPrepaidTypeDropdownComponent implements ICellRendererAngularComp {
  launchDarklyService = inject(LaunchDarklyService);
  mainQuery = inject(MainQuery);

  select = viewChild.required<NgSelectComponent>('select');

  formControl = new FormControl();
  options: AgPrepaidTypeDropdownOption[] = [];
  params!: AgPrepaidTypeDropdownCellEditorParams;

  agInit(params: AgPrepaidTypeDropdownCellEditorParams): void {
    this.params = params;
    this.options = params.options || [];
    this.formControl.setValue(params.data.prepaid_type);
    setTimeout(() => this.select().open());
  }

  getValue(): string {
    return this.formControl.value;
  }

  onChange(): void {
    this.params.node.updateData({
      ...this.params.node.data,
      prepaid_type: this.formControl.value,
    });
  }

  refresh(): boolean {
    return false;
  }

  tooltip(item: AgPrepaidTypeDropdownOption): string {
    return item.disabled ? MessagesConstants.PREPAIDS.INCREASE_ONLY_PAID_INVOICE : '';
  }
}
